import { Box, Grid, List, styled } from "@mui/material";
import { useEffect, useState } from "react";

import { GetMarketListImportantWithGOLD } from "store/api/market";
import SpecialCoinRow from "./SpecialCoinRow";
import SpecialCoinsSkeleton from "./SpecialCoins.skeleton";
import http from "config/http";
import { repeat } from "utils/helpers/interval";
import useNotify from "hooks/useNotify";

function SpecialCoins() {
  const notify = useNotify();
  const [loading, setLoading] = useState(false);
  const [coins, setCoins] = useState();

  const getMarketListImportantWithGOLD = async (isInitial) => {
    try {
      if (isInitial) {
        setLoading(true);
      }

      const { data } = await http.get(GetMarketListImportantWithGOLD);

      setCoins(data?.data);
    } catch (e) {
      notify(e?.response?.data?.message, "error");
    }
    setLoading(false);
  };

  useEffect(() => {
    let getMarketListImportantInterval = null;
    clearInterval(getMarketListImportantInterval);

    getMarketListImportantWithGOLD(true);

    getMarketListImportantInterval = repeat({
      action: getMarketListImportantWithGOLD,
    });

    return () => {
      clearInterval(getMarketListImportantInterval);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid container>
      <Grid item xs={12}>
        {!loading ? (
          <SpecialCoinWrapper>
            <List>
              {coins?.map((coin) => (
                <SpecialCoinRow coin={coin} key={coin?.id} />
              ))}
            </List>
          </SpecialCoinWrapper>
        ) : (
          <SpecialCoinsSkeleton />
        )}
      </Grid>
    </Grid>
  );
}

export const SpecialCoinWrapper = styled(Box)(({ theme }) => ({
  borderRadius: "10px",
  border: `1px solid ${theme.palette.divider}`,
  background: theme.palette.modules.backgroundIconNotification,

  ".MuiList-root": {
    padding: 0,
  },
}));

export default SpecialCoins;
